import { createContext, h } from 'preact';

const SearchContext = createContext();

export default SearchContext;
